var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('v-card',{staticClass:"mt-12 rounded-lg",attrs:{"color":"lightest","text":"","flat":""}},[_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.content.html)}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }